import { required, unique, shape, items, concatFailure, when, fromModel } from '@totalsoft/pure-validations';

export const automaticUserAllocationValidator = concatFailure(
  unique(x => x.dealerId || {}, 'AutomaticUserAllocation.Validators.DealerUnique'),
  items(
    shape({
      dealerId: required,
      allocations: items(
        fromModel(model =>
          shape({
            dealerId: required,
            userId: required |> when(!model.allUsers)
          })
        )
      )
    })
  )
);
